
/**
 * Retorna o objeto openMenus com base no pathname atual.
 */
export const getInitialOpenMenus = pathname => ({
  home: pathname === '/app/home',
  employees: pathname.startsWith('/app/funcionarios'),
  juridicalPerson: pathname.startsWith('/app/pessoa-juridica'),
  contracts: pathname.startsWith('/app/contratos'),
  contract: pathname.startsWith('/app/pessoa-juridica/cadastro-pj'),
  contractEdit: pathname.startsWith('/app/contratos/cadastro-contrato'),
  // boleto: pathname.startsWith('/app/boleto'),
  sales: pathname.startsWith('/app/vendas/cadastro-venda'),
  health: pathname.startsWith('/app/saude'),
});


/**
 * Retorna o novo estado de openMenus, alternando o menu informado e fechando os demais.
 */
export const getNewOpenMenus = (prevOpenMenus, menuId) => {
  const newOpenMenus = { ...prevOpenMenus, [menuId]: !prevOpenMenus[menuId] };
  Object.keys(newOpenMenus).forEach((key) => {
    if (key !== menuId) {
      newOpenMenus[key] = false;
    }
  });
  return newOpenMenus;
};

/**
 * Verifica se o link deve ficar oculto, com base no array de roles permitido e o usertype atual.
 */
export const shouldHideLink = (roles, usertype) => !roles.includes(usertype);

/**
 * Retorna se a feature deve ser exibida, baseado nas flags e no id do menu.
 */
export const canShowFeatureForId = (featureFlags, id) => {
  if (!featureFlags) return true;
  const flags = {
    health: featureFlags.MENU_HEALTH_PANEL || false,
  };
  return flags[id] === undefined ? true : flags[id];
};
